import {NgModule} from "@angular/core";
import {IntDropdownChevronComponent} from "./int-dropdown-chevron.component";
import {CommonModule} from "@angular/common";
import {IntIconModule} from "../../int-icon";

@NgModule({
  imports: [CommonModule, IntIconModule],
  declarations: [IntDropdownChevronComponent],
  exports: [IntDropdownChevronComponent]
})
export class IntDropdownChevronModule {}
